import React, { useEffect, useState } from 'react';
import { Modal, Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../../../../../../Components/Utility/Loader/Loader';
import { useCustomModuleState } from '../../../Context/index';
import { customStylesForOCP, ColumnValues } from '../../../../../../Components/helper';
import BtnAdd from '../../../../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../../../../Components/Utility/FilterAction/BtnDelete';
import * as action from '../../../Store/CustomModule.action';

function DependentControlComponent({ pageIndex, setIsDependent, setIsEditDependent, showEdit, gridIndex, index, deleteItem, onChange, setDroppedIndex }) {
  const { moduleLibId } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const {
    CustomModuleReducer: { customLibraryDetail, customModuleDependentControls },
  } = useSelector((reducer) => reducer);
  const dependentLanguagePath = 'CUSTOM_LIBRARY.DEPENDENT_SETTING';
  const { customModuleState, setCustomModuleState } = useCustomModuleState();
  const [state, setState] = useState({
    hasError: false,
    fixed: true,
    dropDownControl: null,
    isContentArr: [{ isContent: null, to: '' }],
    DependentLoader: false,
    dropDownControlOptions: [],
    isControlOptions: [],
    name: '',
    isLoading: false,
    colourArray: [
      {
        colourValue: '',
        colourType: 'green',
        startPercentage: '',
        endPercentage: '',
      },
      {
        colourValue: '',
        colourType: 'amber',
        startPercentage: '',
        endPercentage: '',
      },
      {
        colourValue: '',
        colourType: 'red',
        startPercentage: '',
        endPercentage: '',
      },
    ],
  });

  async function initialApiCall() {
    setState((prevState) => ({ ...prevState, isLoading: true }));
    await dispatch(action.getDependentPagesList(moduleLibId));
    setState((prevState) => ({ ...prevState, isLoading: false }));
  }

  useEffect(() => {
    initialApiCall();
    setCustomModuleState((prevState) => ({ ...prevState, disableDrag: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (customModuleDependentControls?.length > 0) {
      setState((prevState) => ({
        ...prevState,
        dropDownControlOptions: customModuleDependentControls || [],
      }));
    }
  }, [customModuleDependentControls]);

  useEffect(() => {
    if (customModuleState?.modalEdit) {
      setState((prevState) => ({
        ...prevState,
        ...customModuleState?.editpopupChildData?.relation,
        name: customModuleState?.editpopupChildData?.label,
        isControlOptions: customModuleState?.editpopupChildData?.relation?.dropDownControl?.control?.options || [],
      }));
    }
  }, [customModuleState?.modalEdit, customModuleState?.editpopupChildData?.label, customModuleState?.editpopupChildData?.relation]);

  const handleClose = () => {
    if (moduleLibId) {
      setIsEditDependent(false);
      if (!customLibraryDetail?.pages?.[pageIndex]?.grid?.[gridIndex]?.control?.relation) {
        deleteItem(gridIndex, pageIndex, true);
      }
    } else {
      setIsDependent(false);
      if (!customLibraryDetail?.pages?.[pageIndex]?.grid?.[gridIndex]?.control?.relation) {
        deleteItem(gridIndex, pageIndex);
      }
    }
    setDroppedIndex(-1);
    setCustomModuleState((prevState) => ({
      ...prevState,
      modalEdit: false,
      editPopupGridInd: -1,
      editPopupPageIndex: -1,
      editpopupChildData: null,
      editPopup: false,
      disableDrag: false,
    }));
  };

  function checkColourArray() {
    let valid = true;
    state?.colourArray.forEach((element) => {
      if (
        (element?.colourValue === 'between' && !element?.endPercentage?.trim()?.length) ||
        (element?.colourValue && !element?.startPercentage?.trim()?.length)
      ) {
        valid = false;
      }
    });
    return valid;
  }

  function valiDateState() {
    let valid = true;
    const validCheck = !state?.name || !state?.dropDownControl || state?.isContentArr?.filter((e) => !e?.isContent || !e?.to?.trim()?.length)?.length !== 0;
    const nonFixedCheck = !state?.name || !state?.dropDownControl || !checkColourArray();
    if (state?.fixed ? validCheck : nonFixedCheck) {
      valid = false;
    }
    return valid;
  }

  const handleSubmit = async () => {
    const isValid = await valiDateState();
    if (isValid) {
      if (customModuleState?.modalEdit) {
        setIsEditDependent(false);
        const relationObject = {};
        const keysNeeded = ['fixed', 'dropDownControl', 'isContentArr', 'colourArray'];
        keysNeeded?.forEach((key) => {
          if (state[key] !== null) {
            relationObject[key] = state[key];
          }
        });
        onChange({ relation: relationObject, label: state?.name }, 'relation', customModuleState?.editPopupGridIndex, customModuleState?.editPopupPageIndex);
      } else {
        setIsDependent(false);
        const relationObject = {};
        const keysNeeded = ['fixed', 'dropDownControl', 'isContentArr', 'colourArray'];
        keysNeeded?.forEach((key) => {
          if (state[key] !== null) {
            relationObject[key] = state[key];
          }
        });
        onChange({ relation: relationObject, label: state?.name }, 'relation', gridIndex, pageIndex);
      }
      setCustomModuleState((prevState) => ({
        ...prevState,
        modalEdit: false,
        editPopupGridInd: -1,
        editPopupPageIndex: -1,
        editpopupChildData: null,
        editPopup: false,
        disableDrag: false,
        locationArray: [],
        filteredLocationArray: [],
      }));
    } else {
      setState((prevState) => ({ ...prevState, hasError: true }));
    }
  };

  const handleChange = (key, value, removeArray, colourIndex, contentIndex) => {
    const clonedState = cloneDeep(state);
    handleDepChanges(clonedState, key, value, colourIndex, contentIndex);
    clonedState[key] = value;

    clonedState.hasError = false;
    if (removeArray && removeArray.length > 0) {
      removeArray?.forEach((element) => {
        if (element === 'isContentArr') {
          clonedState.isContentArr = [{ isContent: null, to: '' }];
        } else if (colourIndex !== -1) {
          clonedState.colourArray[colourIndex][element] = null;
        } else if (element === 'colourArray') {
          clonedState[element] = [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ];
        } else {
          clonedState[element] = null;
        }
      });
    }
    if (clonedState.isControlOptions?.length === 1) {
      clonedState.isContentArr?.forEach((element) => {
        if (!element.isContent) {
          element.isContent = clonedState?.isControlOptions?.[0] || null;
        }
      });
    }
    setState((prevState) => ({ ...prevState, ...clonedState }));
  };

  const handleDepChanges = (clonedState, key, value, colourIndex, contentIndex) => {
    if (colourIndex !== -1) {
      clonedState.colourArray[colourIndex][key] = value;
    } else if (contentIndex !== -1) {
      clonedState.isContentArr[contentIndex][key] = value;
    } else if (key === 'dropDownControl') {
      const isControlOptions = value?.control?.options;
      clonedState.isControlOptions = isControlOptions;
      if (isControlOptions?.length === 1) {
        handleChange('isContent', isControlOptions[0], [], -1, contentIndex);
      }
    }
  };

  const chcekingFromDynamicArray = (value) => {
    return typeof value === 'object' ? ColumnValues?.find((ele) => ele?._id === value?._id) : ColumnValues?.find((ele) => ele?._id === value);
  };

  const addContent = () => {
    const clonedState = cloneDeep(state);
    clonedState.isContentArr.push({ isContent: null, to: '' });
    setState(clonedState);
  };
  const deleteCard = (i) => {
    const clonedState = cloneDeep(state);
    clonedState.isContentArr.splice(i, 1);
    setState(clonedState);
  };

  const isContentOption = () => {
    let options = state?.isControlOptions || [];
    if (state?.isContentArr?.length > 0) {
      options = options.filter((e) => !state?.isContentArr?.map((ele) => ele?.isContent?.label).includes(e?.label));
    }
    return options;
  };

  return (
    <Modal className="custom-modal ocp-modal" show={showEdit}>
      <Modal.Header>{t(`${dependentLanguagePath}.DEPENDENT_MODAL_HEADER`)}</Modal.Header>
      <Modal.Body>
        {state?.DependentLoader ? (
          <Loader />
        ) : (
          <>
            <div className="d-flex" key={`dependent_${gridIndex}_${pageIndex}_${index}`}>
              <Row className="px-3">
                <Col lg={12} className="mb-3">
                  <p className="asterisk-req f-14 mb-0">{t(`${dependentLanguagePath}.DEPENDENT_TYPE`)}</p>
                  <div>
                    <div className="d-flex align-items-center">
                      <p className="custom-radio">
                        <input
                          type="radio"
                          id={`dependentFixed_${gridIndex}_${pageIndex}_${index}`}
                          name={`dependentFixed_${gridIndex}_${pageIndex}_${index}`}
                          checked={state?.fixed}
                          onChange={(e) => handleChange('fixed', e?.target?.checked, ['dropDownControl', 'isContentArr', 'colourArray'], -1, -1)}
                        />
                        <label htmlFor={`dependentFixed_${gridIndex}_${pageIndex}_${index}`}>{t(`${dependentLanguagePath}.DEPENDENT_FIXED`)}</label>
                      </p>
                      <p className="custom-radio ml-4">
                        <input
                          type="radio"
                          id={`dependentRange_${gridIndex}_${pageIndex}_${index}`}
                          name={`dependentRange_${gridIndex}_${pageIndex}_${index}`}
                          checked={!state?.fixed}
                          onChange={(e) => handleChange('fixed', !e?.target?.checked, ['dropDownControl', 'isContentArr', 'colourArray'], -1, -1)}
                        />
                        <label htmlFor={`dependentRange_${gridIndex}_${pageIndex}_${index}`}>{t(`${dependentLanguagePath}.DEPENDENT_RANGE`)}</label>
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg="12" className=" mb-3">
                  <p className="asterisk-req f-14 mb-3">
                    {t(`${dependentLanguagePath}.IF_TITLE_NAME`)} <span>*</span>
                  </p>
                  <Select
                    name="dropDownControl"
                    options={
                      state?.fixed
                        ? state?.dropDownControlOptions?.filter((e) => {
                            return e?.control?.key === 'Dropdown';
                          })
                        : state?.dropDownControlOptions?.filter((e) => {
                            return ['Number_Decimal', 'Number_Percentage'].includes(e?.control?.key);
                          }) || []
                    }
                    getOptionLabel={(option) => `${option?.control?.label}`}
                    getOptionValue={(option) => `${option?.i}_${option?.pageId}`}
                    value={state?.dropDownControl}
                    styles={customStylesForOCP}
                    isLoading={state?.isLoading}
                    maxMenuHeight={120}
                    menuPosition="fixed"
                    placeholder={t(`${dependentLanguagePath}.SELECT_CONTROL`)}
                    onChange={(selected) => handleChange('dropDownControl', selected, ['isContentArr', 'colourArray'], -1, -1)}
                  />
                  {state?.hasError && !state?.dropDownControl && <span className="error-message">{t(`${dependentLanguagePath}.IF_TITLE_NAME_MISSING`)}</span>}
                </Col>
                {state?.fixed ? (
                  state?.isContentArr?.map((element, contentIndex) => {
                    return (
                      <Col lg="12" className="d-flex mb-3" key={`${contentIndex}_${element}}`}>
                        <div className="card card-body d-flex flex-row p-2 rounded-0">
                          <div className="mb-2 flex-fill mx-2">
                            <p className="asterisk-req f-14 mb-2">
                              {t(`${dependentLanguagePath}.IS_CONTENT`)} <span>*</span>
                            </p>
                            <Select
                              name="is Option"
                              options={isContentOption()}
                              getOptionLabel={(option) => `${option?.label}`}
                              getOptionValue={(option) => `${option?.uniqueKey}`}
                              value={element?.isContent}
                              styles={customStylesForOCP}
                              maxMenuHeight={120}
                              menuPosition="fixed"
                              isLoading={state?.isLoading}
                              placeholder={t(`${dependentLanguagePath}.SELECT_OPTION`)}
                              onChange={(selected) => handleChange('isContent', selected, [], -1, contentIndex)}
                            />
                            {state?.hasError && !element?.isContent && (
                              <span className="error-message">{t(`${dependentLanguagePath}.IS_CONTENT_MISSING`)}</span>
                            )}
                          </div>
                          <div className="mb-2 flex-fill mx-2">
                            <div className="input-group form-floating-label fixed-label">
                              <input
                                type="text"
                                name="to"
                                placeholder={t(`${dependentLanguagePath}.ENTER_TO`)}
                                className="form-control f-14"
                                maxLength={50}
                                value={element?.to}
                                onChange={(e) => handleChange('to', e?.target?.value, [], -1, contentIndex)}
                              />
                              <label className="asterisk-req f-14 mb-0">
                                {t(`${dependentLanguagePath}.TO`)} <span>*</span>
                              </label>
                            </div>
                            {state?.hasError && !element?.to?.trim().length && (
                              <span className="error-message">{t(`${dependentLanguagePath}.IS_TO_MISSING`)}</span>
                            )}
                          </div>
                        </div>
                        <div className="btn-outline-container">
                          {state?.isControlOptions?.length > 0 && (state?.isContentArr?.length ?? -1) - 1 === contentIndex && (
                            <BtnAdd onBtnClick={addContent} addEditAccess forDisable={state?.isControlOptions?.length === state?.isContentArr?.length} />
                          )}
                          <div className="mb-1" />
                          {state?.isContentArr?.length > 1 && <BtnDelete multiDelete={() => deleteCard(contentIndex)} addEditAccess />}
                        </div>
                      </Col>
                    );
                  })
                ) : (
                  <div className="col-lg-12 d-flex flex-column">
                    {state?.colourArray?.map((element, colourIndex) => {
                      return (
                        <div className="d-flex align-items-center f-14 mb-2" key={`colourArray_${element?.colourType}_${gridIndex}_${pageIndex}_${index}`}>
                          <div className="status-color-container d-flex">
                            <span className={`${element?.colourType} rount-shape`} />
                          </div>
                          <div className="d-flex flex-wrap align-items-center">
                            <span className="px-2 text-nowrap">if</span>
                            <div className="w-180 px-2 my-1 my-md-0">
                              <Select
                                name="colourValue"
                                options={ColumnValues?.filter((ele) => !state?.colourArray?.map((e) => e?.colourValue)?.includes(ele?._id))}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option._id}`}
                                menuPlacement="bottom"
                                menuPosition="fixed"
                                isClearable
                                menuShouldBlockScroll
                                menuShouldScrollIntoView
                                value={chcekingFromDynamicArray(element?.colourValue) || null}
                                styles={customStylesForOCP}
                                isLoading={state?.isLoading}
                                maxMenuHeight={140}
                                onChange={(e) => handleChange('colourValue', e?._id, ['startPercentage', 'endPercentage'], colourIndex, -1)}
                                placeholder={t(`${dependentLanguagePath}.SELECT_VALUE`)}
                              />
                            </div>
                            <input
                              className="form-control text-bordered percentaage-input mx-2"
                              onChange={(e) => handleChange('startPercentage', e?.target?.value, [], colourIndex, -1)}
                              disabled={!element?.colourValue}
                              value={element?.startPercentage || ''}
                              name={`colourStateValue_start_${colourIndex}`}
                              type="number"
                            />{' '}
                            %
                            {element?.colourValue === 'between' && (
                              <div className="d-flex align-items-center ml-1">
                                {' and '}
                                <input
                                  className="form-control text-bordered percentaage-input mx-2"
                                  onChange={(e) => handleChange('endPercentage', e?.target?.value, [], colourIndex, -1)}
                                  disabled={!element?.colourValue}
                                  value={element?.endPercentage || ''}
                                  name={`colourStateValue_end_${colourIndex}`}
                                  type="number"
                                />{' '}
                                %
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    {state?.hasError && !checkColourArray() && <span className="error-message">{t(`${dependentLanguagePath}.IS_COLOUR_ARRAY_MISSING`)}</span>}
                  </div>
                )}
                <Col lg={12} className="mb-3">
                  <div className="input-group form-floating-label fixed-label">
                    <input
                      type="text"
                      name="ColumnName"
                      placeholder="Enter Column Title"
                      className="form-control f-14"
                      maxLength={30}
                      value={state?.name}
                      onChange={(e) => handleChange('name', e?.target?.value, [], -1, -1)}
                    />
                    <label className="asterisk-req f-14 mb-0">
                      {t('CUSTOM_LIBRARY.SOURCE_TYPE.COLUMN_TITLE')} <span>*</span>
                    </label>
                  </div>

                  {state?.hasError && !state?.name?.trim().length && (
                    <span className="error-message">{t('CUSTOM_LIBRARY.SOURCE_TYPE.COLUMN_TITLE_MISSING')}</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="modal-buttons mt-2 mt-md-5 d-flex justify-content-between">
              <button type="button" onClick={handleClose} className="btn btn-default">
                {t('CUSTOM_LIBRARY.SOURCE_TYPE.CANCEL')}
              </button>
              <button type="button" onClick={handleSubmit} className="btn btn-default" disabled={state?.DependentLoader}>
                {t('CUSTOM_LIBRARY.SOURCE_TYPE.CREATE')}
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default DependentControlComponent;
